

export const BASE_URL = '/'
export const HOME_URL = '/home'
export const BUSINESS_URL = '/business'
export const PURCHASE_URL = '/purchase'
